// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"c31aebdd","453":"81803d99","738":"b63fa588","995":"bab52a70"}[chunkId] + ".chunk.js";
};